import { DIALOG_DATA, DialogModule } from '@angular/cdk/dialog';
import { LowerCasePipe } from '@angular/common';
import { Component, computed, inject, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { StaticAssetUrlPipe } from '@rma/public/generic/util/environment';
import { FeatureFlags, featureFlagSignal } from '@rma/public/generic/util/feature-flags';
import { ExternalReview } from '@rma/public/profiles/private/domain';
import { StarRatingComponent } from '@rma/public/reviews/public/ui-rating';

interface ExternReviewData {
  review: ExternalReview;
}

@Component({
  selector: 'rma-external-review',
  imports: [LowerCasePipe, StarRatingComponent, StaticAssetUrlPipe, DialogModule, TranslocoModule],
  providers: [provideTranslocoScope('externalReviews')],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './external-review.component.html',
})
export class ExternalReviewComponent {
  private readonly dialogData = inject<ExternReviewData>(DIALOG_DATA, {
    optional: true,
  });
  private readonly sourceBlocklist: Signal<string[]> = featureFlagSignal(FeatureFlags.ExternalReviewSourceAttributionBlacklist, []);

  public readonly reviewInput = input<ExternalReview | undefined>();

  public readonly review = computed(() => {
    const dialogReview = this.dialogData?.review;
    const inputReview = this.reviewInput();
    return dialogReview ?? inputReview;
  });

  public readonly source = computed(() => {
    const source = this.review()?.externalReviewSource ?? '';
    const blocked = this.sourceBlocklist() ?? [];

    return blocked.includes(source) ? undefined : source;
  });

  public readonly lineClamp = !this.dialogData?.review;
}
